import { IsBoolean, IsOptional } from 'class-validator';
import { NamedEntityDto } from './named.dto';

export class ObjectiveFindingDto extends NamedEntityDto {
  @IsOptional()
  @IsBoolean()
  requireDescription?: boolean;
}
